module.exports = __webpack_public_path__ + "static/media/winter.6ac89322.png";